// extracted by css-extract-rspack-plugin
export default {"editor":"EfdeF"};